import { CreateFile } from '@tran-monorepo/interfaces/files';

const prefix = '[ApplicationAttachments]';

export class LoadApplicationAttachments {
    static readonly type = `${prefix} Load`;
    constructor(
        public readonly applicationId: string,
        public readonly limit = 20
    ) {}
}

export class LoadMoreApplicationAttachments {
    static readonly type = `${prefix} Load More`;
}

export class AddUploadedAttachment {
    static readonly type = `${prefix} Add Uploaded`;
    constructor(public readonly file: import('@tran-monorepo/interfaces/files').File) {}
}

export class UploadAttachment {
    static readonly type = `${prefix} Upload`;
    constructor(public readonly payload: { applicationId: string; fileData: CreateFile; file: File }) {}
}

export class DownloadApplicationAttachment {
    static readonly type = `${prefix} Download`;
    constructor(public readonly payload: { applicationId: string; fileId: string }) {}
}

export class DeleteApplicationAttachment {
    static readonly type = `${prefix} Delete`;
    constructor(public readonly payload: { applicationId: string; fileId: string }) {}
}

export class ClearApplicationAttachmentsState {
    static readonly type = `${prefix} Clear State`;
}

export class CancelAttachmentsLoading {
    static readonly type = `${prefix} Cancel Loading`;
}
